import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CImage, CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler, CFormSelect, } from '@coreui/react'
import { AppSidebarNav } from './AppSidebarNav'
import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'
import Imagem from '../assets/images/icon.png'
import navigation from '../_nav'
import { useContext, useEffect, useRef, useState } from "react";
import factoryApi from '../services/factoryApi';
import { useFactory } from '../Context/factoryContext';
import { useNavigate,useLocation } from 'react-router-dom';

const AppSidebar = () => {
    const dispatch = useDispatch()
    const unfoldable = useSelector((state) => state.sidebarUnfoldable)
    const sidebarShow = useSelector((state) => state.sidebarShow)
    const [factories, setFactories] = useState([])
    const { factorySelected, setFactorySelected } = useFactory()
    const location = useLocation()
    const navigate = useNavigate()


    useEffect(() => {
        const fetchFactories = async () => {
            const response = await factoryApi.index()
            setFactories(response)
        }

        fetchFactories()
    }, [])

    const selectedFactory = factories.find(f => f.hashid === factorySelected)
    const logoUrl = selectedFactory?.brand_logo_url || Imagem

    return (
        <CSidebar
            position="fixed"
            unfoldable={unfoldable}
            visible={sidebarShow}
            onVisibleChange={(visible) => {
                dispatch({ type: 'set', sidebarShow: visible })
            }}
        >
            <CSidebarBrand className="d-none p-2 d-md-flex flex-column align-items-center" to="/">
                <div className="d-flex align-items-center ">
                    <CImage src={Imagem} height={35} alt="Logo" className="me-2 mt-2" />
                    <h4 className="mb-0">VendeAê</h4>
                </div>
                <h6 className="text-secondary fw-normal">admin</h6>
            </CSidebarBrand>

            <CSidebarNav>

                <SimpleBar>
                    <div className="px-2 py-2 w-100">
                        <h6 className="mb-2  text-secondary fw-normal">Fábrica</h6>
                        <div className="d-flex align-items-center ">
                            <CImage
                                src={logoUrl}
                                height={35}
                                width={35}
                                alt="Logo da Fábrica"
                                className="me-2"
                            />
                            <CFormSelect
                                size="md"
                                value={factorySelected}
                                className="flex-grow-1"
                                aria-label="Selecionar fábrica"
                                onChange={(e) => {
                                    const selectedFactory = e.target.value
                                    setFactorySelected(selectedFactory)
                                    if (selectedFactory && location.pathname !== '/products') {
                                        navigate('/products')
                                      }
                                }}
                            >
                                <option value="">Selecione a fábrica</option>
                                {factories.map((factory) => (
                                    <option key={factory.hashid} value={factory.hashid}>
                                        {factory.name}
                                    </option>
                                ))}
                            </CFormSelect>
                        </div>
                    </div>

                    <AppSidebarNav items={navigation} />
                </SimpleBar>
            </CSidebarNav>
            <CSidebarToggler
                className="d-none d-lg-flex"
                onClick={() => dispatch({ type: 'set', sidebarUnfoldable: !unfoldable })}
            />
        </CSidebar>
    )
}

export default React.memo(AppSidebar)
